module.exports = __webpack_public_path__ + "assets/img/business-ecology-icon3.757f393f.png";